import { EMPTY_LIST } from '../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const PROVIDER_FORM_FIELD_NAME_NAME = 'name'

export const PROVIDER_FORM_FIELD_NAME_EMAIL = 'email'

export const PROVIDER_FORM_FIELD_NAME_PHONE = 'phone'

export const PROVIDER_FORM_FIELD_NAME_ADDRESS = 'address'

export const PROVIDER_FORM_FIELD_NAME_CATEGORY = 'categories'

export const PROVIDER_FORM_FIELD_NAME_BUILDING = 'buildings'

export const PROVIDER_FORM_FIELD_NAME_OPENING_HOURS = 'working_hours'

export const PROVIDER_FORM_FIELD_NAME_DESCRIPTION = 'description'

export const PROVIDER_FORM_FIELD_NAME_FILES = 'files'

export const PROVIDER_FORM_INITIAL_VALUES = {
  [PROVIDER_FORM_FIELD_NAME_ADDRESS]: FORMIK_EMPTY_VALUE,
  [PROVIDER_FORM_FIELD_NAME_BUILDING]: EMPTY_LIST,
  [PROVIDER_FORM_FIELD_NAME_CATEGORY]: EMPTY_LIST,
  [PROVIDER_FORM_FIELD_NAME_DESCRIPTION]: FORMIK_EMPTY_VALUE,
  [PROVIDER_FORM_FIELD_NAME_EMAIL]: FORMIK_EMPTY_VALUE,
  [PROVIDER_FORM_FIELD_NAME_NAME]: FORMIK_EMPTY_VALUE,
  [PROVIDER_FORM_FIELD_NAME_OPENING_HOURS]: FORMIK_EMPTY_VALUE,
  [PROVIDER_FORM_FIELD_NAME_PHONE]: FORMIK_EMPTY_VALUE,
}

export const PROVIDER_FORM_NAME_FIELD_MAX_LENGTH = 150

export const PROVIDER_FORM_EMAIL_FIELD_MAX_LENGTH = 255

export const PROVIDER_FORM_ADDRESS_FIELD_MAX_LENGTH = 255

export const PROVIDER_FORM_OPENING_HOURS_FIELD_MAX_LENGTH = 255

export const PROVIDER_FORM_DESCRIPTION_FIELD_MAX_LENGTH = 2048

export const PROVIDER_FORM_MULTI_VALUE_FIELD_MAX_HEIGHT = 288

export const PROVIDER_FORM_PHONE_FIELD_MAX_LENGTH = 15

export const PROVIDER_FORM_SERVER_ERROR_EMAIL_IS_ALREADY_IN_USE =
  'This email is already in use.'

export const PROVIDER_FORM_SERVER_ERRORS = {
  [PROVIDER_FORM_SERVER_ERROR_EMAIL_IS_ALREADY_IN_USE]:
    'Error.ProviderFormEmailIsAlreadyInUserKey',
}
